import type { Address, Card, Position } from "../data/types";
import { t } from "../utils/i18n";
import {
  POOL_COLS,
  POOL_ROWS,
  getSelectionPool,
  getWindow,
  poolIndex,
} from "../utils/sssLogic";
import { CardCell } from "./CardCell";

interface Props {
  cards: Card[];
  position: Position;
  address: Address;
  spriteSrc: string;
}

export function CardPool({ cards, position, address, spriteSrc }: Props) {
  const window = getWindow(position, address);
  const selection = getSelectionPool(position);

  const inWindow = (r: number, c: number) =>
    window.rows.includes(r) && window.cols.includes(c);
  const inSelection = (r: number, c: number) =>
    selection.rows.includes(r) && selection.cols.includes(c);

  return (
    <div className="w-full sm:w-auto">
      <h3 className="mb-1.5 text-center text-xs font-semibold uppercase tracking-wide text-slate-600 sm:text-left">
        {t("cardPool")}
      </h3>
      <div
        className="grid w-full gap-1 rounded border border-slate-300 bg-slate-100 p-1.5 sm:inline-grid sm:w-auto"
        style={{
          gridTemplateColumns: `repeat(${POOL_COLS}, minmax(0, 1fr))`,
          gridTemplateRows: `repeat(${POOL_ROWS}, minmax(0, 1fr))`,
        }}
      >
        {Array.from({ length: POOL_ROWS }).map((_, r) =>
          Array.from({ length: POOL_COLS }).map((_, c) => {
            const variant = inWindow(r, c)
              ? "in-window"
              : inSelection(r, c)
                ? "in-selection"
                : "out";
            const card = cards[poolIndex(r, c)];
            return (
              <CardCell
                key={`${r}-${c}`}
                name={card.name}
                cardClass={card.class}
                variant={variant}
                spriteSrc={spriteSrc}
                poolRow={r}
                poolCol={c}
              />
            );
          }),
        )}
      </div>
    </div>
  );
}
